import React, {useState} from 'react';
import {GetServerSidePropsContext} from 'next';
import {getPageData} from '../[[...slug]]/index.page';
import {useRouter} from 'next/router';
import jsonwebtoken from 'jsonwebtoken';
import ChangePasswordTemplate from '@wearesection/bandai-react-components/organisms/ChangePassword';
import {usePageSetting} from '~/providers/page-context.provider';
import userApi from '../api/services/user-api';
import {handleConvertToLocaleContentful, handleCovertLocale} from '~/utils';
import {getGloablByType} from '~/utils/global-operations';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {BlockRenderer} from '~/components/renderer/block-renderer';
// import userApi from '~/api/user-api';
export type ChangePasswordProps = {
  data: any;
  seo: any;
};
const ChangePassword = (props: ChangePasswordProps) => {
  const {seo} = props;
  const router: any = useRouter();
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const token = router.asPath.substring(router.asPath.indexOf('token') + 6);
  const payload: any = jsonwebtoken.decode(token);
  const isValid = payload?.exp > new Date().getTime() / 1000;
  const [successful, setSuccessful] = useState(false);
  const [isError, setIsError] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const args = {
    mainImage:
      'https://images.ctfassets.net/hnoi7ctzfs57/6yrTqEHiDtnyvWDEJlW6Vn/3c598b64f381f08b22946a9001fcd5a7/Group_124496.jpg',
    mainImageMobile:
      'https://images.ctfassets.net/hnoi7ctzfs57/Syo8j193vfsSf1t0o7kPI/f4a20c1e97bc617ee724124dafad2ed7/Forgot_Password.jpg',
    title: dataTranslation['estore-change-password-title'] ?? '',
    passwordField: {
      label: dataTranslation['estore-change-password-input-password-label'] ?? '',
      emptyField: dataTranslation['estore-change-password-input-password-empty-field'] ?? '',
      helperText: dataTranslation['estore-change-password-input-password-helper-text'] ?? '',
      hiddenLabel: false,
      success: false,
      iconPosEnd: true,
    },
    confirmPasswordField: {
      label: dataTranslation['estore-change-password-input-confirm-password-label'] ?? '',
      emptyField:
        dataTranslation['estore-change-password-input-confirm-password-empty-field'] ?? '',
      helperText:
        dataTranslation['estore-change-password-input-confirm-password-helper-text'] ?? '',
      hiddenLabel: false,
      success: false,
      iconPosEnd: true,
    },
    sendButton: {
      variant: 'primary',
      label: dataTranslation['estore-change-password-submit-button-label'] ?? '',
      disabled: true,
      fullWidth: true,
      handler: async (event: any, props: any, formData: any) => {
        handleChangePassword(formData.password);
      },
    },
    messageErrorPass: {
      errorCharacter: dataTranslation['estore-error-pass-character'],
      error1lowercase: dataTranslation['estore-error-pass-one-lowercase'],
      error1uppercase: dataTranslation['estore-error-pass-one-uppercase'],
      error1special: dataTranslation['estore-error-pass-one-special'],
      error1number: dataTranslation['estore-error-pass-one-number'],
    },
  };

  const handleChangePassword = (password: string) => {
    setLoadingSubmit(true);
    const {locale} = router;
    const data = {
      email: payload.email,
      new_password: password,
      language: handleCovertLocale(`${locale}`.toLowerCase()),
    };
    userApi
      .resetPassWord(data, token)
      .then(response => {
        if (response.status !== 200) {
          throw response;
        }
        setSuccessful(true);
        setIsError(false);
        setLoadingSubmit(false);
        setTimeout(() => {
          router.push('/login');
        }, 3000);
      })
      .catch(error => {
        console.log('error: ', error);
        setIsError(true);
        setSuccessful(false);
        setLoadingSubmit(false);
      });
  };
  const handleReturnTitleNotify = (): string => {
    if (!isValid) {
      return dataTranslation['estore-token-expired'] || '';
    }
    if (isError) {
      return dataTranslation['estore-account-label-update-pass-error'] || '';
    }
    if (successful) {
      return dataTranslation['estore-account-label-update-pass-success'] || '';
    }
    return '';
  };
  const SeoStandard = seo?.['change-password']
    ? {
        __typename: 'SeoStandard',
        ...seo['change-password'],
      }
    : null;

  return (
    <>
      {SeoStandard && <BlockRenderer block={[SeoStandard]} />}
      <ChangePasswordTemplate
        {...args}
        successful={successful}
        isError={!isValid || isError}
        titleNotify={handleReturnTitleNotify()}
        isErrorToken={!isValid}
        loadingSubmit={loadingSubmit}
      />
      s
    </>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);
  const promises: [ReturnType<typeof getPageData>, ReturnType<typeof getGloablByType>] = [
    getPageData({slug: 'store', preview}, ctx),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.SEO),
  ];
  const [pageData, seo] = await Promise.all(promises);
  const {data} = pageData;
  return {
    props: {
      data,
      seo,
    },
  };
};
export default ChangePassword;
